import { render } from "./CartCellTotal.vue?vue&type=template&id=4ce6c44f"
import script from "./CartCellTotal.vue?vue&type=script&lang=js"
export * from "./CartCellTotal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__